import { PromotionalEventType } from '../../indigofair/common/PromotionalEventType';
import { IBrand } from '../../indigofair/data/IBrand';
import { IImage } from '../../indigofair/data/IImage';
import { IProduct } from '../../indigofair/data/IProduct';
import { IProductOption } from '../../indigofair/data/IProductOption';

export namespace IRetailerBoard {
  export namespace IItem {
    /**
     * Return an instance of IItem with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (partial?: Partial<IItem>): IItem =>
      ({
        ...(partial ?? {}),
      }) as IItem;
  }

  export interface IItem {
    product: IProduct | undefined;
    product_option: IProductOption | undefined;
    image: IImage | undefined;
    token: string | undefined;
    text: string | undefined;
    source_url: string | undefined;
    brand: IBrand | undefined;
    board_token: string | undefined;
    created_at: number | undefined;
    updated_at: number | undefined;
  }

  export namespace IRetailerInfo {
    /**
     * Return an instance of IRetailerInfo with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (partial?: Partial<IRetailerInfo>): IRetailerInfo =>
      ({
        ...(partial ?? {}),
      }) as IRetailerInfo;
  }

  export interface IRetailerInfo {
    token: string | undefined;
    name: string | undefined;
    owner_image: IImage | undefined;
    state: string | undefined;
    city: string | undefined;
    is_faire_retailer: boolean | undefined;
  }

  export type BoardTypeType =
    | 'DEFAULT'
    | 'MY_BOARD'
    | 'OTHER'
    | 'BOARD_SUGGESTION';

  export enum BoardType {
    DEFAULT = 'DEFAULT',
    MY_BOARD = 'MY_BOARD',
    OTHER = 'OTHER',
    BOARD_SUGGESTION = 'BOARD_SUGGESTION',
  }

  export type BoardItemTypeType =
    | 'BOARD_ITEM_TYPE_UNKNOWN'
    | 'PRODUCT_ONLY'
    | 'BRAND_ONLY';

  export enum BoardItemType {
    BOARD_ITEM_TYPE_UNKNOWN = 'BOARD_ITEM_TYPE_UNKNOWN',
    PRODUCT_ONLY = 'PRODUCT_ONLY',
    BRAND_ONLY = 'BRAND_ONLY',
  }

  /**
   * Return an instance of IRetailerBoard with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IRetailerBoard>): IRetailerBoard =>
    ({
      cover_images: [],
      ...(partial ?? {}),
    }) as IRetailerBoard;
}

export interface IRetailerBoard {
  token: string | undefined;
  name: string | undefined;
  description: string | undefined;
  /**
   * Up to the 3 first product images for this board,
   * to be used as a cover image composite.
   */
  cover_images: Array<IImage>;
  items_count: number | undefined;
  is_private: boolean | undefined;
  board_type: keyof typeof IRetailerBoard.BoardType | undefined;
  board_item_type: keyof typeof IRetailerBoard.BoardItemType | undefined;
  promotional_event_type: keyof typeof PromotionalEventType | undefined;
  retailer_info: IRetailerBoard.IRetailerInfo | undefined;
  last_changed_by_user: number | undefined;
  created_at: number | undefined;
  updated_at: number | undefined;
  promotional_event_key: string | undefined;
}
